// extracted by mini-css-extract-plugin
module.exports = {"cost":"StoreItem_cost__21hRO"};